import { Context } from '../server-middleware/context'

export default async function getHTMLFromUrl (context: Context, url: string): Promise<string> {
  if (!url) return ''
  const response = await context.axios.get(url)
  return response.data
}
